import React from 'react';
import { TeamLogos, TeamsList, TOOLTIPS } from '../../../globals/Globals';

export interface Props {
    teamname: string;
}

function TeamLogo({teamname}:Props) {
    const teamLogo = TeamLogos[teamname]? TeamLogos[teamname] : '';
    return <img src={teamLogo} style={{width: "60px", height: '60px', marginLeft: '1rem', marginRight: "auto"}}/>
}

export default TeamLogo

